import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private refreshTokenTimeout: any;

  constructor() { }

  isLoggedIn(): boolean {
    const token = localStorage.getItem("user_token");
    if (token) {
      try {
        const payload = JSON.parse(window.atob(token.split(".")[1])); // decode JWT payload
        const currentTime = Math.floor(Date.now() / 1000); // current time in seconds

        // console.log("Token Expires At:", payload.exp);
        // console.log("Current Time:", currentTime);

        return payload.exp > currentTime;
      } catch (e) {
        console.error("Invalid token format", e);
        return false;
      }
    } else {
      console.log("No token found in local storage");
      return false;
    }
  }

  setToken(token: string): void {
    localStorage.setItem("user_token", token);
  }

  clearToken(): void {
    localStorage.removeItem("user_token");
    this.stopRefreshTokenTimer();
  }

  private stopRefreshTokenTimer(): void {
    clearTimeout(this.refreshTokenTimeout);
  }
}
